import { render, staticRenderFns } from "./CriteriaSearchArea.vue?vue&type=template&id=fad8a6fa&scoped=true"
import script from "./CriteriaSearchArea.vue?vue&type=script&lang=js"
export * from "./CriteriaSearchArea.vue?vue&type=script&lang=js"
import style0 from "./CriteriaSearchArea.vue?vue&type=style&index=0&id=fad8a6fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad8a6fa",
  null
  
)

export default component.exports